"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeValidators = exports.checkErrors = exports.customValidator = exports.dependent = exports.pattern = exports.maxlength = exports.minlength = exports.required = void 0;
// Default Error Messages
var MESSAGES = {
  REQUIRED: 'required',
  MIN: 'too short',
  MAX: 'too long',
  PATTERN: 'pattern error'
  /* 
  !@function: internal
  * name: _checkRequired
  * Description: function to check whether a field is required or not
  * @param: value {string} : value given by react-final-form
  * @param: rule {Object} : Object containing the required key
  * @return {Boolean}
  */

};

var _checkRequired = function _checkRequired(value, rule) {
  return rule.required && !value;
};
/* 
!@function: internal
* name: _checkMin
* Description: min length checker 
* @param: value {string} : value given by react-final-form
* @param: rule {Object} : Object containing the minlength key
* @return {Boolean}
*/


var _checkMin = function _checkMin(value, rule) {
  return value && rule.minlength && value.length < rule.minlength;
};
/* 
!@function: internal
* name: _checkMax
* Description: max length checker 
* @param: value {string} : value given by react-final-form
* @param: rule {Object} : Object containing the maxlength key
* @return {Boolean}
*/


var _checkMax = function _checkMax(value, rule) {
  return value && rule.maxlength && value.length > rule.maxlength;
};
/* 
!@function: internal
* name: _checkPattern
* Description: pattern validator 
* @param: value {string} : value given by react-final-form
* @param: rule {Object} : Object containing the pattern key
* @return {Boolean}
*/


var _checkPattern = function _checkPattern(value, rule) {
  return value && rule.pattern && !value.match(rule.pattern);
};
/* 
!@function: internal
* name: _checkDependent
* Description: pattern validator 
* @param: allValue {Object} : Object containing all the values, which are touched, by the react-final-form
* @param: value {string} : value given by react-final-form
* @param: rule {Object} : Object containing the dependent and condition key
* @return {Boolean}
*/


var _checkDependent = function _checkDependent(allValues, rule, value) {
  if (!allValues) {
    return;
  }

  var dependent = rule.dependent,
      condition = rule.condition;
  var dependentValue = allValues[dependent];

  if (condition === 'required' && _checkRequired(dependentValue)) {
    return true;
  }

  if (condition === 'match' && dependentValue === value) {
    return true;
  }

  return false;
};
/* 
!@function
* name: checkErrors
* Description: function to check for errors over a given fieldName
* @param: fieldName {string} : current field for which validations are to be checked
* @param: currentFieldRulesArray {Array} : array of objects corresponding to the given fieldName
* @param: allValues {Object} : Values given by the Final form
* @return {Object}: error object
*/


var checkErrors = function checkErrors(fieldName, currentFieldRulesArray, allValues) {
  var error; //! iterate over each rule defined for that fieldName

  var previousErrorFlag = false;
  currentFieldRulesArray.forEach(function (rule) {
    var value = allValues[fieldName];

    if (_checkRequired(value, rule)) {
      error = rule.msg || MESSAGES.REQUIRED;
      previousErrorFlag = true;
    } else if (_checkMin(value, rule)) {
      error = rule.msg || MESSAGES.MIN;
      previousErrorFlag = true;
    } else if (_checkMax(value, rule)) {
      error = rule.msg || MESSAGES.MAX;
      previousErrorFlag = true;
    } else if (_checkPattern(value, rule)) {
      error = rule.msg || MESSAGES.PATTERN;
      previousErrorFlag = true;
    } else if (value && rule.dependent && _checkDependent(allValues, rule, value)) {
      error = rule.msg;
      previousErrorFlag = true;
    } else if (value && rule.customValidator && typeof rule.customValidator === 'function') {
      if (!previousErrorFlag) {
        var retVal = rule.customValidator(value, allValues);

        if (typeof retVal === 'string') {
          error = retVal;
        } else if (retVal) {
          error = rule.msg;
        }
      }
    }
  });
  previousErrorFlag = false;
  return error;
}; // functions which are used to validate the dynamically added fields

/* 
!@function
* name: required
* Description: Required validatoe
* @param: msg {string} : error message
* @return {string| undefined}
*/


exports.checkErrors = checkErrors;

var required = function required(msg) {
  var rule = {
    required: true
  };
  msg = msg || MESSAGES.REQUIRED;
  return function (value) {
    return _checkRequired(value, rule) ? msg : undefined;
  };
};
/* 
!@function
* name: minlength
* Description: Minimum length validator
* @param: minlength {number} : minimum length limit
* @param: msg {string} : error message
* @return {string| undefined}
*/


exports.required = required;

var minlength = function minlength(_minlength, msg) {
  var rule = {
    minlength: _minlength,
    msg: msg
  };
  msg = msg || MESSAGES.MIN;
  return function (value) {
    return _checkMin(value, rule) ? msg : undefined;
  };
};
/* 
!@function
* name: maxlength
* Description: Maximum length validator
* @param: maxlength {number} : maxlength limit
* @param: msg {string} : error message
* @return {string| undefined}
*/


exports.minlength = minlength;

var maxlength = function maxlength(_maxlength, msg) {
  var rule = {
    maxlength: _maxlength,
    msg: msg
  };
  msg = msg || MESSAGES.MIN;
  return function (value) {
    return _checkMax(value, rule) ? msg : undefined;
  };
};
/* 
!@function
* name: pattern
* Description: Pattern validator
* @param: pattern {Object} : Regex Object
* @param: msg {string} : error message
* @return {string| undefined}
*/


exports.maxlength = maxlength;

var pattern = function pattern(_pattern, msg) {
  var rule = {
    pattern: _pattern,
    msg: msg
  };
  msg = msg || MESSAGES.PATTERN;
  return function (value) {
    return _checkPattern(value, rule) ? msg : undefined;
  };
};
/* 
!@function
* name: dependent
* Description: Function to validate a field on the value of some other field
* @param: rule {Object} : object containing the name of dependent field and condition
*                          {
*                            dependent: 'username',
*                            condition: 'match', OR 'required'
*                            msg: 'this cannot be same as user name'
*                          }
* @param: msg {string} : error message
* @return {string| undefined}
*/


exports.pattern = pattern;

var dependent = function dependent(rule) {
  var msg = rule.msg || MESSAGES.DEPENDENT;
  return function (value, allValues) {
    return _checkDependent(allValues, rule, value) ? msg : undefined;
  };
};
/* 
!@function
* name: customValidator
* Description: customised function which is used when you are required to write your validation logic
* @param: callback {function} : callback function which will be fired by the validation
* @return {function} : function with arguments as
*                      arg1: current field value
*                      arg2: allValues of the form in an object
*/


exports.dependent = dependent;

var customValidator = function customValidator(callback) {
  if (typeof callback === 'function') {
    return function (value, allValues) {
      return callback(value, allValues);
    };
  }
};
/* 
!@function
* name: composeValidators
* Description: Function to compose multiple validators (given above) on a field
* @param: validators {functions} : 
* @return {function} : composed function
*/


exports.customValidator = customValidator;

var composeValidators = function composeValidators() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return function (value) {
    return validators.reduce(function (error, validator) {
      return error || validator(value);
    }, undefined);
  };
};

exports.composeValidators = composeValidators;